/* This file is autogenerated, see readme.md for instructions */
import ExposeSvgIcon from '@bloomreach/banana-theme/icons/expose.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ExposeIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ExposeSvgIcon />
    </Icon>
  );
});

ExposeIcon.displayName = 'ExposeIcon';

export default ExposeIcon;
